import React from "react";
import { Modal, Box, Typography, Button, CircularProgress } from "@mui/material";
import SectionTitle from "../common/SectionTitle";

interface BulkDeleteConfirmationModalProps {
  open: boolean;
  count: number;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const BulkDeleteConfirmationModal: React.FC<BulkDeleteConfirmationModalProps> = ({
  open,
  count,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <Modal open={open} onClose={loading ? undefined : onCancel}>
      <Box
        role="dialog"
        aria-label="Confirm delete"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <SectionTitle title="Confirm Delete" />
        <Typography sx={{ mb: 2 }}>
          {`Delete ${count} ${count === 1 ? "transcription" : "transcriptions"}? This can't be undone.`}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button variant="outlined" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} color="inherit" aria-label="Deleting" /> : "Delete"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default BulkDeleteConfirmationModal;
